import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import List from '@mui/material/List';
import { default as ListItem } from '@mui/material/ListItem';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import './CRFstyles.scss';
import moment from 'moment';
import { useCRFForms } from './useCRFForms';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { PopupComponent } from '../../common/PopupComponent';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import clsx from 'clsx';
import { CrfInterface } from './crfVisitEventsMenuInterface';

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
  ({ theme }) => ({
    border: `0px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    }
  })
);

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ChevronRightIcon sx={{ fontSize: '1.6rem' }} />} {...props} />
))(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)'
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1)
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '0px solid rgba(0, 0, 0, .125)'
}));

function CRFVisitEventsMenu({
  visitsData,
  setselectedVisit,
  selectedVisit,
  setmodifiedFormConfig,
  seteditRowData,
  editRowData,
  bookMarkField,
  exitValue,
  setExitValue,
  currentAddedEvent,
  isUpdate,
  bookMarkKey,
  currentEditEventData,
  isAddCliked,
  isAddMode,
  setisUpdate,
  selectedAppointment
}: any) {
  const { unSavedWarning } = useFieldTranslation();
  const [currentVisitId, setVisitId] = useState(null);
  const [currentEventtId, setcurrentEventtId] = useState(null);
  const [exitPopup, setExitPopup] = useState(false);
  const [tempData, setTempData] = useState<any>({});
  const [clonedvisitsData, setvisitsData] = useState<any>(null);

  useEffect(() => {
    if (selectedVisit) {
      setVisitId(selectedVisit.study_visit.id);
    }
  }, []);

  useEffect(() => {
    if (editRowData) {
      setcurrentEventtId(editRowData.event_uuid);
    }
  }, [editRowData]);

  useEffect(() => {
    if (currentAddedEvent && !isUpdate) {
      if (currentAddedEvent[0]?.event_uuid) {
        setcurrentEventtId(currentAddedEvent[0]?.event_uuid);
      } else {
        setcurrentEventtId(currentAddedEvent[0]?.event_number);
      }
    }
  }, [currentAddedEvent, isUpdate]);

  useEffect(() => {
    if (currentAddedEvent) {
      const clonedData = visitsData?.map((item: any) => {
        const sortedCrfsData = [...item.crf_data];
        sortedCrfsData.sort((a: any, b: any) => a.result.event_number - b.result.event_number);
        if (selectedAppointment?.study_visit?.visit_id == item.study_visit.id && isAddCliked) {
          return {
            ...item,
            crf_data: [
              ...sortedCrfsData,
              {
                result: isNaN(currentAddedEvent[0]?.event_number)
                  ? {
                      id: currentAddedEvent[0].event_number,
                      ...currentAddedEvent[0],
                      event_number: item.crf_data.length == 0 ? 1 : item.crf_data[0].result?.event_number + 1
                    }
                  : {
                      id: currentAddedEvent[0].event_number,
                      event_number: item.crf_data.length == 0 ? 1 : item.crf_data[0].result?.event_number + 1
                    }
              }
            ]
          };
        } else {
          return { ...item, crf_data: sortedCrfsData };
        }
      });
      setvisitsData(clonedData);
    }
  }, [currentAddedEvent, selectedAppointment, visitsData]);

  const handleChangeEventData = (visit: any, data: any) => {
    if (exitValue) {
      setExitPopup(true);
      setTempData({ visit, data });
    } else {
      setVisitId(visit.study_visit.id);
      setselectedVisit(visit);
      const clonedObj = JSON.parse(JSON.stringify(visit.visit_crf));
      clonedObj.update = true;
      clonedObj.coustome = true;
      seteditRowData(data);
      // setmodifiedFormConfig(clonedObj);
      if (data.event_uuid) {
        setisUpdate(true);
      } else {
        setisUpdate(false);
      }
    }
  };

  const { userPreferedDateFormat } = usePreferedDateFormat();
  const handleExitPopupClose = () => {
    setExitPopup(false);
  };
  const handleExitPopupSubmit = () => {
    setExitPopup(false);
    setExitValue(false);
    setVisitId(tempData.visit.study_visit.id);
    setselectedVisit(tempData.visit);
    const clonedObj = JSON.parse(JSON.stringify(tempData.visit.visit_crf));
    clonedObj.update = true;
    seteditRowData(tempData.data);
    setmodifiedFormConfig(clonedObj);
  };
  const { getCheckboxValue, getRadioButtonValue } = useCRFForms();
  const getFormattedDate = (date: any, type: string): string => {
    const formatString =
      type === 'date_time'
        ? `${userPreferedDateFormat.toUpperCase()} h:mm A`
        : `${userPreferedDateFormat.toUpperCase()}`;
    return moment(date)?.format(formatString);
  };
  const getValue = (value: any): string => {
    if (bookMarkField?.cmp === 'select' && typeof value === 'object') {
      return bookMarkField.multiple && 'key' in value ? value.key.map((v: any) => v?.label).join(', ') : value?.label;
    }
    if (bookMarkField?.cmp === 'checkbox' || bookMarkField?.cmp === 'radio') {
      return `.${
        bookMarkField.cmp === 'checkbox'
          ? getCheckboxValue(bookMarkField, value)
          : getRadioButtonValue(bookMarkField, value)
      }`;
    }
    return value?.toString();
  };
  const formatBookmarkValue = (obj: CrfInterface): string | null => {
    const currentEvent = currentEditEventData?.eventData;
    const currentEventInitial = currentEditEventData?.initialValues;
    if (isAddCliked && obj.result?.initialValues) {
      const value = obj.result?.initialValues[bookMarkKey];
      return bookMarkField?.cmp === 'date' ? getFormattedDate(value, bookMarkField.type) : getValue(value);
    }
    if (
      currentEvent &&
      currentEvent?.visit_id === currentVisitId &&
      currentEvent?.id === obj.result.id &&
      currentEventInitial
    ) {
      const value = currentEventInitial[bookMarkKey];
      return bookMarkField?.cmp === 'date' ? getFormattedDate(value, bookMarkField.type) : getValue(value);
    }
    if (obj?.result?.bookmark_key_value) {
      const value = obj.result.bookmark_key_value;
      return bookMarkField?.cmp === 'date' ? getFormattedDate(value, bookMarkField.type) : getValue(value);
    }
    return bookMarkField && bookMarkField?.fieldKey === 'label' ? bookMarkField.title : null;
  };

  return (
    <div style={{ overflow: 'auto', maxHeight: 'calc(100vh - 104px)' }} className="fullModalAccordionWrap">
      {clonedvisitsData && clonedvisitsData.length > 0
        ? clonedvisitsData.map((item: any, index: number) => {
            return (
              item?.visit_appointment?.is_visit_started == 'in_progress' && (
                <Accordion defaultExpanded={currentVisitId === item.study_visit.id} key={`clonedvisitsData${index}`}>
                  <AccordionSummary
                    aria-controls="panel1d-content"
                    id={item.study_visit.id}
                    onClick={() => setVisitId(item.study_visit.id)}
                  >
                    <Typography>
                      <strong>
                        {item?.unscheduled_visit !== null
                          ? item?.unscheduled_visit
                          : item.study_visit.protocol_visit_name}
                      </strong>
                    </Typography>
                    <Typography variant="body2" className="acc_Date">
                      {item?.study_visit?.visit_date
                        ? moment(item.study_visit?.visit_date).format(`${userPreferedDateFormat.toUpperCase()}`)
                        : null}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <List className="accordionStyles">
                      {item.crf_data && item.crf_data.length > 0
                        ? item.crf_data.map((obj: CrfInterface, dataIndex: number) => {
                            return (
                              <ListItem
                                key={`itemcrf_data${dataIndex}`}
                                className={clsx([
                                  currentEventtId ==
                                  (obj?.result?.event_uuid ? obj?.result?.event_uuid : obj?.result?.id)
                                    ? 'selected'
                                    : '',
                                  obj.result.event_status == 'Deleted' ? 'disableDeletedCRFEvent' : ''
                                ])}
                                onClick={() => handleChangeEventData(item, obj.result)}
                              >
                                <div className="body3"># {obj.result.event_number}</div>
                                <div className="body2">{formatBookmarkValue(obj)}</div>
                                <div className="body2">
                                  {moment(obj.result.date_of_entry).format(`${userPreferedDateFormat.toUpperCase()}`)}
                                </div>
                              </ListItem>
                            );
                          })
                        : null}
                    </List>
                  </AccordionDetails>
                </Accordion>
              )
            );
          })
        : null}
      <PopupComponent
        open={exitPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleExitPopupClose} className="grey-btn">
            Close
          </Button>
          <Button onClick={handleExitPopupSubmit} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </PopupComponent>
    </div>
  );
}

export default CRFVisitEventsMenu;
